class ProductModal extends ModalDialog {
  constructor() {
    super();

    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );

    this.thumbnailList = this.querySelector(
      ".product-media-modal__thumbnail-list"
    );
    this.thumbnails = Array.from(
      this.querySelectorAll(".product-media-modal__thumbnail")
    );
    this.thumbnailHandlers = this.thumbnails.map(
      (el) => () => this.showMedia(el.dataset.mediaId)
    );

    this.thumbnails.forEach((el, index) => {
      el.addEventListener("click", this.thumbnailHandlers[index], false);
    });
  }

  show(mediaId) {
    super.show();

    document.body.classList.add("overflow-hidden");

    this.showMedia(mediaId);
  }

  showMedia(mediaId) {
    if (!mediaId) {
      return;
    }
    Array.from(this.querySelectorAll("zoom-image")).forEach((el) => {
      if (el.dataset.mediaId === mediaId) {
        el.show();
      } else {
        el.hide();
      }
    });
  }

  setActiveMedia(mediaId) {
    const activeMedia = this.thumbnailList.querySelector(
      `.thumbnail-list__item[data-media-id="${mediaId}"]`
    );
    if (activeMedia) {
      this.thumbnailList.prepend(activeMedia);
    }
  }
}

customElements.define("product-modal", ProductModal);
